import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { reviewsData } from "../../../mocks/yokohamaData";

export default function ReviewsSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-navy text-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
                {reviewsData.label}
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold leading-tight">
                {reviewsData.title}
              </h2>
              <p className="mt-3 text-sm text-white/60 max-w-2xl mx-auto leading-relaxed">
                {reviewsData.subtitle}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {reviewsData.items.map((item, idx) => (
              <ScrollReveal key={item.name} direction="up" delay={idx * 100}>
                <div className="p-6 bg-airdoa-navy-light rounded-lg border border-white/10 h-full">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <p className="text-sm font-medium text-white">{item.name}</p>
                      <p className="text-xs text-white/50">{item.age}</p>
                    </div>
                    <span className="px-2.5 py-1 text-[10px] font-medium text-airdoa-gold bg-airdoa-navy rounded border border-airdoa-gold/30">
                      {item.scene}
                    </span>
                  </div>
                  <p className="text-sm text-white/80 leading-[1.9]">{item.comment}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-8 text-center">
              <Link to="/reviews" className="btn-ghost">
                お客様の声をもっと見る
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
